/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_TALENT_TAG_LIST
 */
export const listTagsQueryPageDefault = 1;export const listTagsQueryPageSizeDefault = 100;export const listTagsQuerySortDescendingDefault = false;

export const listTagsQueryParams = zod.object({
  "page": zod.number().default(listTagsQueryPageDefault),
  "pageSize": zod.number().default(listTagsQueryPageSizeDefault),
  "search": zod.string().optional(),
  "isActive": zod.boolean().optional(),
  "sortBy": zod.string().optional(),
  "sortDescending": zod.boolean().optional()
})




export const listTagsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().min(1),
  "description": zod.string().nullish(),
  "hexColor": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "assignedTalentMemberCount": zod.number()
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_TALENT_TAG_CREATE
 */
export const createTalentTagBody = zod.object({
  "name": zod.string(),
  "description": zod.string().nullish(),
  "hexColor": zod.string().nullish(),
  "isActive": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_TALENT_TAG_GET
 */
export const getTalentTagByIdParams = zod.object({
  "id": zod.string().uuid()
})




export const getTalentTagByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().min(1),
  "description": zod.string().nullish(),
  "hexColor": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "assignedTalentMemberCount": zod.number()
})

/**
 * **Required Permission(s):** ORG_TALENT_TAG_UPDATE
 */
export const updateTalentTagParams = zod.object({
  "id": zod.string().uuid()
})

export const updateTalentTagBody = zod.object({
  "name": zod.string(),
  "description": zod.string().nullish(),
  "hexColor": zod.string().nullish(),
  "isActive": zod.boolean()
})




export const updateTalentTagResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().min(1),
  "description": zod.string().nullish(),
  "hexColor": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "assignedTalentMemberCount": zod.number()
})

/**
 * **Required Permission(s):** ORG_TALENT_TAG_DELETE
 */
export const deleteTalentTagParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_TALENT_TAG_GET
 */
export const getTalentMembersWithTagParams = zod.object({
  "id": zod.string().uuid()
})

export const getTalentMembersWithTagResponseItem = zod.object({
  "id": zod.string().uuid(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "email": zod.string().nullish()
})
export const getTalentMembersWithTagResponse = zod.array(getTalentMembersWithTagResponseItem)

/**
 * **Required Permission(s):** ORG_TALENT_MEMBER_ADD_TAG
 */
export const addTagToTalentMemberParams = zod.object({
  "id": zod.string().uuid(),
  "talentMemberId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_TALENT_MEMBER_REMOVE_TAG
 */
export const removeTagFromTalentMemberParams = zod.object({
  "id": zod.string().uuid(),
  "talentMemberId": zod.string().uuid()
})

